import { FireSysAdmin } from './fire/sys_admin';
import { FireOpAdmin } from './fire/op_admin';
import { FireOpUser } from './fire/op_user';

import { FireGroup } from './fire/group';
import { FireOpr } from './fire/opr';

export class Session {
  //================================================================================================
  //  変数定義
  //============================|===================================================================
  isLogin                       : boolean;                                                          //  ログイン中
  is2FA                         : boolean;                                                          //  ２要素認証中
  uid                           : string | null;                                                    //  UID
  sysAdmin                      : FireSysAdmin | null;                                              //  システム管理者
  opAdmin                       : FireOpAdmin | null;                                               //  OP管理者
  opUser                        : FireOpUser | null;                                                //  CAユーザー
  group                         : FireGroup | null;                                                 //  選択グループ
  opr                           : FireOpr | null;                                                   //  選択OPレジストリ
  //================================================================================================
  //  コンストラクタ
  //============================|===================================================================
  constructor() {
    this.isLogin                = false;
    this.is2FA                  = false;
    this.uid                    = null;
    this.sysAdmin               = null;
    this.opAdmin                = null;
    this.opUser                 = null;
    this.group                  = null;
    this.opr                    = null;
  }
  //================================================================================================
  //  リセット
  //================================================================================================
  reset(): Session {
    this.isLogin                = false;
    this.is2FA                  = false;
    this.uid                    = null;
    this.sysAdmin               = null;
    this.opAdmin                = null;
    this.opUser                 = null;
    this.group                  = null;
    this.opr                    = null;
    return this;
  }
}
